<div class="d-flex justify-content-end pe-2 py-2">
	<button class="me-2" mat-raised-button color="primary" (click)="copyToClipboard()">
		Skopiuj <i class="fas fa-copy"></i>
	</button>
	@if (tabType() === ListTabType.SMS) {
		<button [disabled]="!selection.selected?.length" mat-raised-button color="primary" (click)="smsDialogOpen()">
			Generuj SMS <i class="fa-solid fa-comment-sms"></i>
		</button>
	}
</div>
<div class="dynamic-table">
	<mat-table
		mat-table
		[dataSource]="dataSource()"
		[ngStyle]="{
			width: tableWidth(),
		}"
		matSort
	>
		<ng-container matColumnDef="checkbox">
			<mat-header-cell *matHeaderCellDef>
				<mat-checkbox
					color="primary"
					(change)="$event ? toggleAllRows() : null"
					[checked]="selection.hasValue() && isAllSelected()"
					[indeterminate]="selection.hasValue() && !isAllSelected()"
				>
				</mat-checkbox>
			</mat-header-cell>
			<mat-cell *matCellDef="let element"
				><mat-checkbox
					color="primary"
					(click)="$event.stopPropagation()"
					(change)="$event ? selection.toggle(element) : null"
					[checked]="selection.isSelected(element)"
				>
				</mat-checkbox
			></mat-cell>
		</ng-container>

		<ng-container matColumnDef="Lp">
			<mat-header-cell *matHeaderCellDef> LP </mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="smsSent">
			<mat-header-cell *matHeaderCellDef> SMS status </mat-header-cell>
			<mat-cell *matCellDef="let element"
				><i class="fa-solid fa-paper-plane" [class]="element.slot.smsSent ? 'text-success' : 'text-muted'"></i
			></mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopDeparture">
			<mat-header-cell *matHeaderCellDef mat-sort-header>Miasto wyjazdu</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{
					transportSide() === TransportSide.DEPARTURE
						? element.slot.stopDeparture?.stop.location.name
						: element.slot?.stopReturn?.stop.location.name
				}}</mat-cell
			>
		</ng-container>

		<ng-container matColumnDef="status">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.slot.status | statusLabel }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="unique">
			<
			<mat-header-cell *matHeaderCellDef mat-sort-header> Unikat </mat-header-cell>
			<mat-cell *matCellDef="let element">{{
				element.reservation.id + element.slot.userData?.firstName + element.slot.userData?.lastName
			}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="bc">
			<mat-header-cell *matHeaderCellDef mat-sort-header> BC </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a [routerLink]="'../../../reservation/' + element.reservation.id" target="_blank">{{
					element.reservation.id
				}}</a>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="firstName">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Imie </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (element.slot.userData) {
					{{ element.slot.userData.firstName }}
				} @else {
					{{ element.reservation.ownerUser.firstName }}
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="lastName">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Nazwisko </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (element.slot.userData) {
					{{ element.slot.userData.lastName }}
				} @else {
					{{ element.reservation.ownerUser.lastName }}
					<span class="text-sm"> &nbsp;(zgłaszający)</span>
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="slotCount">
			<mat-header-cell *matHeaderCellDef mat-sort-header> il.rez </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.reservationSlotCount }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="seats">
			<mat-header-cell
				*matHeaderCellDef
				matTooltip="jednopiętrowy wyjazd/jednopiętrowy powrót/dwupiętrowy wyjazd/dwupiętrowy powrót"
				mat-sort-header
			>
				Miejsca
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (element.slot.seatnumber) {
					{{ element.slot.seatnumber.singleDeckDeparture?.number }}/{{
						element.slot.seatnumber.singleDeckReturn?.number
					}}/{{ element.slot.seatnumber.doubleDeckDeparture?.number }}/{{
						element.slot.seatnumber.doubleDeckReturn?.number
					}}
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="insurer">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Ubezpieczyciel </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.insurerName }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="comfort">
			<mat-header-cell *matHeaderCellDef mat-sort-header> PAK </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@let isPAK = checkPackageComfort(element.slot);
				{{ isPAK ? 'PAK' : '' }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="phone">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Tel </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (element.slot.userData && element.slot.userData.userContacts[0]?.phone) {
					{{ element.slot.userData?.userContacts[0]?.phone }}
				} @else {
					{{ element.reservation.ownerUser?.userContacts[0]?.phone }}
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="product">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Produkt </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.product.name }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="note">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Notatka </mat-header-cell>
			<mat-cell *matCellDef="let element">
				@for (note of element.notes; track note.id; let isLast = $last) {
					{{ note?.content }}{{ isLast ? '' : ', ' }}
				}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="board">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Wyżywienie </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.board.name }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="accommodation">
			<mat-header-cell *matHeaderCellDef> Zakwaterowanie </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.destination?.name }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="otherCities">
			<mat-header-cell *matHeaderCellDef> Inne miasta </mat-header-cell>
			<mat-cell *matCellDef="let element"></mat-cell>
		</ng-container>

		<ng-container matColumnDef="birth">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Data ur. </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.slot.userData?.birth }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="vehicle">
			<mat-header-cell *matHeaderCellDef> Pojazd </mat-header-cell>
			<mat-cell *matCellDef="let element"></mat-cell>
		</ng-container>

		<ng-container matColumnDef="surchargeCost">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Koszty Pro. </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element?.surchargeFee || 0 | price }}
				{{ element?.surchargeCurrency?.code }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="nights">
			<mat-header-cell *matHeaderCellDef> Liczba Noclegów </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.slot.nightsStay }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="signature">
			<mat-header-cell *matHeaderCellDef> Podpis </mat-header-cell>
			<mat-cell *matCellDef="let element"></mat-cell>
		</ng-container>

		<ng-container matColumnDef="acceptanceSignature">
			<mat-header-cell *matHeaderCellDef> Podpis przyjęcia </mat-header-cell>
			<mat-cell *matCellDef="let element"></mat-cell>
		</ng-container>

		<ng-container matColumnDef="dedicationSignature">
			<mat-header-cell *matHeaderCellDef> Podpis oddania </mat-header-cell>
			<mat-cell *matCellDef="let element"></mat-cell>
		</ng-container>

		<ng-container matColumnDef="address">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Adres </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.slot.stopDeparture?.stop.address }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopDepartureDate">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
			<mat-cell *matCellDef="let element">{{
				element.slot.stopDeparture?.timeDeparture | date: 'yyyy-MM-dd'
			}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="stopDepartureHour">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Godzina </mat-header-cell>
			<mat-cell *matCellDef="let element">{{
				element.slot.stopDeparture?.timeDeparture | date: 'HH:mm'
			}}</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true" class="mat-header-custom"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
	</mat-table>
</div>
@if (isLoadingResults()) {
	<div class="spinner-container">
		<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
	</div>
}
